<script setup lang="ts">
import { usePage } from "@inertiajs/vue3"
import { ChevronsUpDown } from "lucide-vue-next"

import UserInfo from "@/components/UserInfo.vue"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import type { Auth } from "@/types"

import UserMenuContent from "./UserMenuContent.vue"

const page = usePage()
const auth = page.props.auth as Auth
const { isMobile, state } = useSidebar()
</script>

<template>
  <SidebarMenu>
    <SidebarMenuItem>
      <DropdownMenu>
        <DropdownMenuTrigger as-child>
          <SidebarMenuButton
            size="xl"
            class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
          >
            <UserInfo :user="auth.user" />
            <ChevronsUpDown class="ml-auto size-4" />
          </SidebarMenuButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          class="w-(--reka-dropdown-menu-trigger-width) min-w-56 rounded-lg"
          :side="
            isMobile ? 'bottom' : state === 'collapsed' ? 'left' : 'bottom'
          "
          align="end"
          :side-offset="4"
        >
          <UserMenuContent :auth="auth" />
        </DropdownMenuContent>
      </DropdownMenu>
    </SidebarMenuItem>
  </SidebarMenu>
</template>
